<template>
  <div id="app">
    <router-view />
    <!-- 按键收缩移动 -->
    <!-- <div
      class="app1"
      ref="bear"
      @mousedown="move($event)"
      :style="{'backgroundImage': 'url('+global.iconPic.bear+')', 'opacity': bearOpacity}"
      :class="keyShow ? 'bearMenu' : ''"
      @dblclick="keyShow=!keyShow"
    >
      <ul v-show="keyShow">
        <li class="xzx-keyboard" @click.stop="keyboardSys()">
          <img :src="global.iconPic.keyboard" alt />
          <p>键盘</p>
        </li>
        <li class="xzx-small" @click.stop="gosmall()">
          <img :src="global.iconPic.small" alt />
          <p>最小化</p>
        </li>
        <li class="xzx-scale" @click.stop="scaleSys()">
          <img :src="global.iconPic.scale" alt />
          <p>窗口化</p>
        </li>
        <li class="xzx-offsys" @click.stop="offSys()">
          <img :src="global.iconPic.offsys" alt />
          <p>退出</p>
        </li>
      </ul>
    </div> -->
    <floatbtn :style="{'opacity': getOpcity}" v-show="getOpcity > 0"></floatbtn>
  </div>
</template>


<script>
import Floatbtn from '@/components/Floatbtn.vue';
export default {
  components: { Floatbtn },
  data() {
    return {
      bearOpacity: 0.5,
      keyShow: false,
    };
  },
  methods: {
    //获取软件设置
    async getSetting() {
      let { data } = await this.$post("api/system/config/info", { status: 1 }, {noStopRepeat: true});
      this.bearOpacity = Number(data.data.list.opacity.replace(/%/g, "")) / 100;
      this.$store.commit("setOpcity", this.bearOpacity);
    },
    move() {
      let e = e || window.event;
      console.log(e);
      let bear = this.$refs.bear;
      //小熊的宽高
      let bearW = bear.clientWidth;
      let bearH = bear.clientHeight;
      //鼠标位置减掉小熊偏移量
      var positionX = e.clientX - bear.offsetLeft;
      var positionY = e.clientY - bear.offsetTop;
      document.onmousemove = function (e) {
        //获取小熊的位置
        var divX = e.clientX - positionX;
        var divY = e.clientY - positionY;
        //设置小熊不超出页面可视范围
        if (divX <= 0) {
          divX = 0;
        } else if (divX >= document.body.clientWidth - bearW) {
          divX = document.body.clientWidth - bearW;
        }
        if (divY <= 0) {
          divY = 0;
        } else if (divY >= document.body.clientHeight - bearH) {
          divY = document.body.clientHeight - bearH;
        }
        //给小熊赋值
        bear.style.left = divX + "px";
        bear.style.top = divY + "px";
      };
      document.onmouseup = function () {
        document.onmousemove = null;
      };
      //触摸屏移动
      document.ontouchmove = function () {
        console.log(e);
      };
      document.ontouchend = function () {
        document.ontouchmove = null;
      };
    },
    offSys() {
      let obj = "";
      try {
        obj = FingerprintObj;
      } finally {
        if (obj == "") {
          this.$myMessage("当前状态下，没有此功能！");
        } else {
          obj.closeWindow();
        }
      }
    },
    scaleSys() {
      let obj = "";
      this.keyShow = !this.keyShow;
      try {
        obj = FingerprintObj;
      } finally {
        if (obj == "") {
          this.$myMessage("当前状态下，没有此功能！");
        } else {
          obj.min_max_click();
        }
      }
    },
    keyboardSys() {
      this.keyShow = !this.keyShow;
      let obj = "";
      try {
        obj = FingerprintObj;
      } finally {
        if (obj == "") {
          this.$myMessage("当前状态下，没有此功能！");
        } else {
          obj.openKeyboard();
        }
      }
    },
    gosmall() {
      this.keyShow = !this.keyShow;
      let obj = "";
      try {
        obj = FingerprintObj;
      } finally {
        if (obj == "") {
          this.$myMessage("当前状态下，没有此功能！");
        } else {
          obj.setMinSize();
        }
      }
    },
    //自动同步
    async autoTb() {
      try {
        let str = FingerprintObj.getMacAddress();
        let { data } = await this.$post("api/msg/macHost");
        let macsId = data.data.mac;
        let macId = str.replace(/-/g, ":");
        setInterval(async () => {
          await this.$post("api/msg/obtion", {
            mac: macId,
            hostmac: macsId,
          });
        }, 1000 * 60 * 30);
      } catch (error) {
        return error;
      }
    },
  },
  created() {
    localStorage.setItem("step", 0);
  },
  mounted() {
    this.getSetting();
    this.autoTb();
  },
  computed: {
    getOpcity() {
      return this.$store.state.opcity;
    },
  },
  watch: {
    // getOpcity() {
    //   this.getSetting();
    // },
  },
};
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
}
html,
body {
  min-width: 1920px;
  min-height: 1080px;
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  -khtml-user-select: none; /*早期浏览器*/
  user-select: none;
  -webkit-app-region: no-drag;
  //overflow: hidden;
}
body::-webkit-scrollbar {
  display: none;
}
#app {
  font-family: Microsoft YaHei, Microsoft YaHei-Regular, siyaun-heiti;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  font-size: 16px;
}
ul,
li {
  list-style: none;
}
.app1 {
  position: fixed; /*定位*/
  top: 10px;
  left: 10px;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  z-index: 1000000;
  opacity: 0.6;
  ul {
    position: relative;
    p {
      color: #fff;
      font-size: 18px;
    }
    img {
      width: 38px;
    }
    .xzx-keyboard {
      position: absolute;
      top: -80px;
      left: 20px;
      text-align: center;
    }
    .xzx-small {
      position: absolute;
      top: 0px;
      left: -78px;
      text-align: center;
    }
    .xzx-scale {
      position: absolute;
      top: 12px;
      right: -78px;
      text-align: center;
    }
    .xzx-offsys {
      position: absolute;
      bottom: -160px;
      left: 20px;
      text-align: center;
    }
  }
}
.bearMenu {
  border: 100px solid rgba(51, 51, 51, 0.8);
}
</style>
